module.exports = __webpack_public_path__ + "img/mbanner3.c7641bd5.jpg";